module.exports = __webpack_public_path__ + "static/media/usd-circle.57f2a9ac.svg";